import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import SpaIcon from '@mui/icons-material/Spa';
import Container from '@mui/material/Container';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import  getLPTheme from '../getLPTheme';
import Copyright from "../Copyright";
import {useContext} from "react";
import { AuthContext} from "../index";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import App from './App';
import AuthBySMSForm from './AuthBySMSForm';
import {useLocation, useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useState, useRef} from 'react';


const theme = createTheme();

export default function Login() {
    const { onLogin } = useContext(AuthContext);
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);

        onLogin({
            email: data.get('email'),
            password: data.get('password'),
        });
    };

    const lightTheme = createTheme(getLPTheme('light'));


    const [ button , setButton ] = useState({ text: '', loading: false })
    let handleButtonClick = () => {}
    let setButtonClick = (action) => {
        handleButtonClick = action;
    }

    return (
        <App>
            <Box
                sx={{
                    // position: 'absolute',
                    // top: '50%',
                    // lef: '50%',
                    // transform: 'translate(-50%,-60%)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%'
                }}
            >
                <Stack spacing={3} sx={{justifyContent: 'center', alignItems: 'center'}}>
                    <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                        {/*<LockOutlinedIcon />*/}
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Войти в аккаунт <br/> с помощью смс кода
                    </Typography>
                    <AuthBySMSForm
                        setButton={ setButton }
                        setButtonClick={ setButtonClick }
                    />
                </Stack>
            </Box>
        </App>
    );
}
